import { Schedule } from './schedules';
import { MultiLanguage } from './misc';
import { CampaignClustersDiscountsRecord } from '@/types/campaigns';
import { AdSpace } from '@/types/adspaces';
import { ScreenCluster } from '@/types/screen-cluster';

type DiscountReason = MultiLanguage;
export interface Discount {
  discountReason: DiscountReason;
  discountValue: number;
  discountType?: PromotionType;
  screenClusterId?: ScreenCluster['ID'];
  code?: Promotion['CODE'];
}

export interface PromotionType {
  RATE: PromotionRate;
  VALUE: number;
}

export interface Promotion {
  ID?: string;
  CODE: string;
  NAME: string;
  REDEEM_MESSAGE: MultiLanguage;
  PLATFORM_MESSAGE: MultiLanguage;
  PLATFORM_VISIBLE: boolean;
  START_DATE: string;
  END_DATE: string;
  TYPE: PromotionType;
  /** @deprecated  now we use APPLICABLE_AD_SPACE_IDS*/
  APPLICABLE_SCREEN_CLUSTER_IDS: Schedule['ID'][];
  APPLICABLE_AD_SPACE_IDS: AdSpace['ID'][];
  MINIMUM_NUMBER_OF_WEEKS_IN_CAMPAIGN: number|null;
  FIRST_PUBLISHED_CAMPAIGN_ONLY: boolean;
  VALUE_CAP?: number|null;
  WEEKS_PERIOD_CAP?: number|null;
  DEFAULT?: boolean;
}

export const PROMOTION_STATUSES = {
  ACTIVE: 'ACTIVE' as 'ACTIVE',
  EXPIRED: 'EXPIRED' as 'EXPIRED',
  UPCOMING: 'UPCOMING' as 'UPCOMING',
};

export const PROMOTION_RATES = {
  DISCOUNT: 'DISCOUNT' as 'DISCOUNT',
  FIXED_PRICE: 'FIXED_PRICE' as 'FIXED_PRICE',
};

export type PromotionRate = keyof typeof PROMOTION_RATES;

export type PromotionStatus = keyof typeof PROMOTION_STATUSES;

export interface PromoCodeData {
  code?: string;
  error?: string;
  status?: 'APPLIED'|'ERROR';
  redeemMessage?: MultiLanguage;
}

export interface CampaignDiscounts {
  errorMessage?: string;
  totalDiscount: number;
  discountList: Discount[];
  screenClustersDiscountsRecord?: CampaignClustersDiscountsRecord;
}
export const PROMOTION_REDEEM_ERROR_MESSAGES = {
  campaignNotEligibleForPromotion: 'campaign_not_eligible_for_promotion' as 'campaign_not_eligible_for_promotion',
  userAlreadyHasPublishedCampaigns: 'user_already_has_published_campaigns' as 'user_already_has_published_campaigns',
  invalidPromoCode: 'invalid_promo_code' as 'invalid_promo_code',
  promotionExpired: 'promotion_expired' as 'promotion_expired',
  promotionNotStarted: 'promotion_has_not_started' as 'promotion_has_not_started',
}

type PromotionRedeemErrorNames = keyof typeof PROMOTION_REDEEM_ERROR_MESSAGES;
export type PromotionRedeemError = typeof PROMOTION_REDEEM_ERROR_MESSAGES[PromotionRedeemErrorNames];